import React from 'react';
import { prop } from 'ramda';
import { useFormatter } from 'js/hooks/useFormatter';

import { LIMIT_TYPE } from '../../constants';
import { useDynamicReducerSelector } from '../../store';

import style from './PendingLimits.scss';

export const PendingLimits = ({ translate }) => {
    const formatter = useFormatter();
    const pendingLimits = useDynamicReducerSelector(prop('pendingLimits'));

    if (!pendingLimits.length) {
        return null;
    }

    return (
        <div className={style.container}>
            <h2 className={style.title}>{translate('title.pending')}</h2>
            <div className={style.limits}>
                {pendingLimits.map((limit) => {
                    const { amount, startDate, currencyCode, limitType } = limit;
                    const text = `${translate(`${
                        limitType === LIMIT_TYPE.AUTOMATIC_WITHDRAW_LIMIT
                            ? 'limit.pending'
                            : 'amountToBeLeftOnBalance.pending'
                    }`)}`;

                    return (
                        <div key={limitType} className={style.pending}>
                            <span className={style.text}>
                                {`${text} ${formatter.formatCurrency(amount, { currencyCode })}`}
                            </span>
                            <span className={style.date}>
                                {startDate && formatter.getDateTimeShort(formatter.parseImsDate(startDate))}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
